import { useEffect, useState } from 'react';
import API from '../api/axios';
import './Dashboard.css';

const Dashboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    API.get('/dashboard')
      .then(res => setData(res.data))
      .catch(console.error);
  }, []);

  if (!data) return <div>Yükleniyor...</div>;

  return (
    <div>
      <h1 style={{ color: '#fff', marginBottom: 24 }}>📊 Dashboard</h1>
      <div className="stats-grid">
        <div className="stat-card">
          <span className="stat-icon">👑</span>
          <div className="stat-value">{data.totalManagers}</div>
          <div className="stat-label">Toplam Yönetici</div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">👥</span>
          <div className="stat-value">{data.activeMembers}</div>
          <div className="stat-label">Aktif Üye</div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">💰</span>
          <div className="stat-value">{data.revenue.today} USDT</div>
          <div className="stat-label">Bugünkü Gelir</div>
        </div>
        <div className="stat-card">
          <span className="stat-icon">📅</span>
          <div className="stat-value">{data.revenue.month} USDT</div>
          <div className="stat-label">Aylık Gelir</div>
        </div>
      </div>
      <div className="recent-section">
        <h3>Son Ödemeler</h3>
        {data.recentPayments.map(p => (
          <div key={p.id} className="payment-row">
            <span>@{p.member_username}</span>
            <span>{p.amount} {p.currency}</span>
            <span className={`status ${p.status}`}>{p.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;